module.exports = require('./quote-edit').extend({
    queryParams: {
        fromQuoteId: 'from_quote_id',
        newContactId: 'contact_id',
        newType: 'new_type'
    },

    fromQuoteId: null,
    newContactId: null,
    newType: 'quote'
})
